<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('kjmb.title')}}</div>
        </div>
        <div class="cotainer quickBuyCoins">
            <ul class="ul-box">
                <li class="li" v-for="(item,index) in listData" :key="index" @click="goDetail(item.id)">
                    <template v-if="lang == 'ar'">
                      <div class="text">{{item.title}}</div>
                      <img class="icon" style="margin: 0 0 0 .3rem" :src="item.img_url" alt="">
                    </template>
                    <template v-else>
                      <img class="icon" :src="item.img_url" alt="">
                      <div class="text">{{item.title}}</div>
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'quicklyBuyCoins',
    data () {
        return {
            theme: false,
            listData: [],
            lang: 'en'
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getQuick();
    },
    methods: {
        back(){
            this.$router.push('/user')
        },
        getQuick(){
            this.$ajax.get('/web/getQuick',{}).then((res) => {
                let resData = res.data.data;
                this.listData = resData;
            }).catch(function(err){
                console.log(err)
            })
        },
        goDetail(id){
            this.$router.push({ path: '/quicklyBuyCoinsDetail', query: { id: id } })
        }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .ul-box{
        padding: 0 .3rem;
        background: #fff;
    }
    .cotainer .ul-box .li{
        display: flex;
        align-items: center;
        padding: .4rem 0;
        color: #000;
        font-size: .42rem;
        border-bottom: 1px solid #ececec;
    }
    .cotainer .ul-box .li .icon{
        width: .9rem;
        height: .9rem;
        margin-right: .3rem;
    }
    .cotainer .ul-box .li .arrow{
        width: .24rem;
    }
    .cotainer .ul-box .li:last-child{
        border-bottom: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/quicklyBuyCoins.vue